import { render, staticRenderFns } from "./24.vue?vue&type=template&id=0fc816bd&scoped=true&"
import script from "./24.vue?vue&type=script&lang=js&"
export * from "./24.vue?vue&type=script&lang=js&"
import style0 from "./24.vue?vue&type=style&index=0&id=0fc816bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc816bd",
  null
  
)

export default component.exports